import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ConferenciaContagemRequest } from '../../requests/compras/conferencia-contagem.request';
import { ConferenciaIniciarRequest } from '../../requests/compras/conferencia-iniciar.request';
import { ConferenciaProblemaRequest } from '../../requests/compras/conferencia-problema.request';
import { ConferenciaReabrirRequest } from '../../requests/compras/conferencia-reabrir.request';
import { ConferenciaProblemaResponse } from '../../responses/compras/conferencia-problema.response';
import { ConferenciaResponse } from '../../responses/compras/conferencia.response';
import { ConferenciaSituacaoResponse } from '../../responses/compras/conferencia-situacao.response';

/** Conferência física por NF (etapa Conferência do Kanban de Compras): volumes e itens, API Compras. */
@Injectable({
  providedIn: 'root',
})
export class ConferenciaService extends CommonService {
  private readonly apiUrl: string = environment.urlApiCompras + 'Conferencia';

  constructor(private httpClient: HttpClient) {
    super();
  }

  public obterSituacao(idNFeEntrada: number): Observable<ConferenciaSituacaoResponse> {
    return this.httpClient
      .get<ConferenciaSituacaoResponse>(`${this.apiUrl}/idNFeEntrada/${idNFeEntrada}`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /** Idempotente: se a ação já está Em andamento, devolve a existente. */
  public iniciar(request: ConferenciaIniciarRequest): Observable<ConferenciaResponse> {
    return this.httpClient
      .post<ConferenciaResponse>(`${this.apiUrl}/iniciar`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public salvarContagem(request: ConferenciaContagemRequest): Observable<ConferenciaResponse> {
    return this.httpClient
      .put<ConferenciaResponse>(`${this.apiUrl}/contagem`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public concluir(request: ConferenciaContagemRequest): Observable<ConferenciaResponse> {
    return this.httpClient
      .post<ConferenciaResponse>(`${this.apiUrl}/concluir`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /** Volta a ação concluída para Em andamento; no modo cego, zera a contagem. */
  public reabrir(request: ConferenciaReabrirRequest): Observable<ConferenciaResponse> {
    return this.httpClient
      .post<ConferenciaResponse>(`${this.apiUrl}/reabrir`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public registrarProblema(request: ConferenciaProblemaRequest): Observable<ConferenciaProblemaResponse> {
    return this.httpClient
      .post<ConferenciaProblemaResponse>(`${this.apiUrl}/problema`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
